import { render, staticRenderFns } from "./PostShareMenu.vue?vue&type=template&id=48cd046b&scoped=true"
import script from "./PostShareMenu.vue?vue&type=script&lang=js"
export * from "./PostShareMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd046b",
  null
  
)

export default component.exports